import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { tomos, tomoIncludes } from '../data/content';
export function PackOverview() {
  return <section id="contenido" aria-labelledby="contenido-titulo" className="w-full bg-navy py-14 text-white sm:py-20" data-id="element-182" data-mp="3m8o4b52yqf42">
      <div className="mx-auto max-w-6xl px-5" data-id="element-183" data-mp="3haw47ns5zmos">
        <div className="mx-auto max-w-3xl text-center" data-id="element-184" data-mp="2tjz3761wq9sb">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-widest text-navy-deep" data-id="element-185" data-mp="2tks4hri3k732">
            🏆 MegaPack™ Caligrafía y Lectoescritura
          </span>
          <h2 id="contenido-titulo" className="mt-5 font-display text-3xl font-extrabold leading-tight text-balance sm:text-4xl lg:text-5xl" data-id="element-186" data-mp="32ic7p5zisdgb">
            El sistema completo. Todo el año. Todo resuelto.
          </h2>
          <p className="mt-4 font-display text-base font-bold text-gold sm:text-lg" data-id="element-187" data-mp="ds2szhmuz9xs">
            6 Tomos + 6 Bonos · 480+ páginas · Tomo 1 → Tomo 6
          </p>

          <div className="mt-6 space-y-4 text-left text-base leading-relaxed text-celeste-light sm:text-lg" data-id="element-188" data-mp="2bjprhvjc92fj">
            <p data-id="element-189" data-mp="2fl1gbyue1jmo">
              Esto no es una colección de fichas sueltas. Es el único sistema que cubre el
              camino completo — desde “no sabe tomar el lápiz” hasta “escribe en cursiva” —
              en español rioplatense, con guía para el adulto en cada paso, progresión por
              nivel y registro visible del avance.
            </p>
            <p className="font-bold text-white" data-id="element-190" data-mp="1rtw6q1f1jnkt">
              Porque el problema nunca fue la dedicación. Fue que el sistema no existía.
            </p>
          </div>
        </div>

        <h3 className="mt-14 text-center font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-191" data-mp="21n36n6r0ibdi">
          📚 Los 6 Tomos — El camino completo
        </h3>

        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-192" data-mp="194pg7s809rog">
          {tomos.map((tomo, index) => <motion.li key={tomo.id} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.06,
          ease: 'easeOut'
        }} className="flex h-full flex-col rounded-2xl bg-white p-5 text-navy shadow-card" data-id="element-193" data-mp="2cfd5eevwa6js" data-mpi={index}>
              <span className="text-2xl" aria-hidden="true" data-id="element-194" data-mp="1tik7g5bs8hj4">
                {tomo.emoji}
              </span>
              <h4 className="mt-2 font-display text-lg font-extrabold leading-tight" data-id="element-195" data-mp="1ojr435q7m6wo">
                {tomo.title}
              </h4>
              <p className="font-display text-sm font-bold text-celeste-dark" data-id="element-196" data-mp="22fulfyfzikrq">
                {tomo.subtitle}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-navy/75" data-id="element-197" data-mp="3dwun3ko82byf">
                {tomo.description}
              </p>
              <p className="mt-auto pt-3 text-sm font-bold leading-snug text-navy" data-id="element-198" data-mp="38x9f6kr2qt9k">
                {tomo.highlight}
              </p>
            </motion.li>)}
        </ul>

        <div className="mt-12 rounded-2xl border border-white/15 bg-white/5 p-6 sm:p-8" data-id="element-199" data-mp="3lh58plphd36s">
          <h3 className="font-display text-xl font-extrabold text-gold" data-id="element-200" data-mp="37hnf8t18p1r3">
            Cada tomo incluye:
          </h3>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-201" data-mp="3ch9t94ow6m0y">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-202" data-mp="41gd4qyh3ckf">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-celeste" aria-hidden="true" data-id="element-203" data-mp="8z8eebl0cb1a" />
                <span className="text-sm leading-relaxed text-white/90 sm:text-base" data-id="element-204" data-mp="3qfggzs04n5mw">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}